import React, { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PackageHeader from "./PackageHeader";
import PackageTable from "./PackageTable";

const PackageList = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <PackageHeader />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <PackageTable />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default PackageList;
